import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { UpdateVehicle, Vehicle } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { driverKeys } from '../../drivers/api';
import { createVehicleApi, vehicleKeys } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UpdateVehicleVariables {
  body: UpdateVehicle;
  id: string;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useUpdateVehicle(): UseMutationResult<Vehicle, Error, UpdateVehicleVariables> {
  const client = useApiClient('admin-auth');
  const api = createVehicleApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<Vehicle, Error, UpdateVehicleVariables>({
    mutationFn: ({ body, id }: UpdateVehicleVariables) => api.updateVehicle(id, body),
    ...createMutationCallbacks({
      invalidateKeys: [vehicleKeys.all, driverKeys.all],
      queryClient,
      successKey: 'vehicles.toast.updateSuccess',
      t,
    }),
  });
}
